"use strict";

// Class definition
var SigninGeneral = function () {
    // Elements
    var email
    var email_value
    var btn_cont
    var oauth_g_btn
    var google_btn

    const { SAlert } = require("../../helpers/alert");
    const { errorResponse, successResponse } = require('../../helpers/axios');

    var hasLand = () => {

        const url = window.location.href;
        const urlObj = new URL(url);
        const params = new URLSearchParams(urlObj.search);

        return params.has('land')
    }

    var isEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    var goToRegister = () => {

        email_value = email.value.trim()
        if (email_value == "") {
            SAlert({
                color: 'danger',
                colorButton: 'primary',
                buttonOkText: _('Aceptar'),
                title: _('Error'),
                message: _("Ingrese un Email"),
                callback: () => {}
            });  
            return false
        }
        if (!isEmail(email_value)) {
            SAlert({
                color: 'danger',
                colorButton: 'primary',
                buttonOkText: _('Aceptar'),
                title: _('Error'),
                message: _("Ingrese un Email válido (ejemplo@ejemplo.com)"),
                callback: () =>  {}
            });
            return false
        }

        btn_cont.classList.add("disabled")

        axios.post('/auth/check-email', {
            email: email_value
        }).then(function (response) {

            let successFunction = () => {
                if (response.data.status == "used") {

                    btn_cont.classList.remove("disabled")
                    SAlert({
                        color: 'warning',
                        colorButton: 'primary',
                        title: _("Lo sentimos"),
                        message: _('Ya existe un usuario con ese email'),
                        callback: () => {}
                    });
                } else {
                    let new_url = `/auth/sign-up?email=${email_value}`

                    if (hasLand()) {
                        new_url+="&land=True"
                    }
                    window.location.href = new_url
                }
            };
            return successResponse(response, successFunction);

        }).catch(function (error) {

            btn_cont.classList.remove("disabled")

            let errorsWrapper = false;
            let validator = null;
            let failureFunction = () => {

                SAlert({
                    color: 'danger',
                    colorButton: 'primary',
                    title: _("Lo sentimos"),
                    message: _('Hubo un error al revisar el email'),
                    callback: () => {}
                });

            };

            return errorResponse(error, errorsWrapper, failureFunction, validator);

        }).then(function () {
        });
    }

    var signInGoogle = () => {

        let new_url = "/auth/google-oauth-req?mode=register"

        if (hasLand()) {
            new_url+="&land=True"
        }

        window.location.href = new_url
        
    }

    // Public functions
    return {
        // Initialization
        init: function () {

            email = document.getElementById("email")

            btn_cont = document.getElementById("btn-cont")
            btn_cont.addEventListener("click", () => goToRegister())

            oauth_g_btn = document.getElementById("oauth-g-btn")
            oauth_g_btn.addEventListener("click", () => signInGoogle())

            google_btn = document.querySelectorAll("[role='button']")
            for (let i = 0; i<google_btn.length; i++) {
                google_btn[i].replaceWith(google_btn[i].cloneNode(true));
                
            }
        }
    };
}();

// On document ready
KTUtil.onDOMContentLoaded(function () {
    SigninGeneral.init();
});
